<template>
  <div>
    <div class="title">如何查询退货信息？</div>
    <div class="content-info">
      <p class="txt1">请联系在线客服或致电{{$concatPhone || '4006-135-135' }}查询退货信息。</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "register",
  data() {
    return {};
  }
};
</script>

<style lang="scss" scoped>
</style>
